import React from 'react';
import { connect } from 'react-redux';
import styles from './budget-bubble.scss';
import PropTypes from 'prop-types';
import Tooltip from '../tooltip';
import { setActiveProject } from '../../actions/index';
import { formatNumber } from '../../modules/bubbleHelper';
import { isIOS } from '../../modules/navigatorHelper';
import { gaTracking } from '../../modules/ga';
import Button from '../button';
import * as selectors from '../../reducers';
import { clusterAcronyms } from '../../reducers/projects';

class BudgetBubble extends React.Component {
  constructor() {
    super();
    this.state = {
      tooltipVisible: false,
    };
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
    this.setActiveProject = this.setActiveProject.bind(this);
  }

  componentDidUpdate() {}

  showTooltip() {
    if (isIOS) {
      this.setActiveProject();
    } else {
      if (this.props.activeProject) return null;
      this.setState({ tooltipVisible: true });
    }
  }

  hideTooltip() {
    if (this.props.activeProject) return null;
    this.setState({ tooltipVisible: false });
  }

  renderBudget() {
    const { project } = this.props;
    if (!project.budget) return null;
    return 'Budget: ' + formatNumber(project.budget);
  }

  setActiveProject() {
    const { setActiveProject, project } = this.props;
    this.setState({ tooltipVisible: false });
    setActiveProject(project);
    gaTracking('Project click', {
      event_label: project.name,
    });
  }

  isTooltipVisible() {
    const { activeProject, project } = this.props;
    if (
      (activeProject && activeProject.id === project.id) ||
      this.state.tooltipVisible
    ) {
      return true;
    } else {
      return false;
    }
  }

  renderButton() {
    const { project } = this.props;
    return project.link ? <Button link={project.link} /> : '';
  }

  renderSubtitle() {
    const { project } = this.props;
    return project.subtitle ? (
      <div className={`${styles.tooltipInfo} ${styles.tooltipInfoDark}`}>
        {project.subtitle}
      </div>
    ) : null;
  }

  getStripeUrl() {
    const { color } = this.props;
    switch (color) {
      case '#0a7cb9':
        return `url(${process.env.PUBLIC_URL}/img/stripe_blue.png)`;
      case '#04b0a8':
        return `url(${process.env.PUBLIC_URL}/img/stripe_green.png)`;
      case '#00abe6':
        return `url(${process.env.PUBLIC_URL}/img/stripe_light-blue.png)`;
      default:
        return `url(${process.env.PUBLIC_URL}/img/stripe_green.png)`;
    }
  }

  render() {
    const { size, color, project, isStriped, tabChangeRequested } = this.props;
    const tooltipVisible = this.isTooltipVisible();
    return (
      <div
        style={{
          backgroundColor: color,
          width: size,
          height: size,
          backgroundImage: isStriped ? this.getStripeUrl() : 'none',
        }}
        className={`${styles.bubble} ${tabChangeRequested
          ? styles.bubbleLeaving
          : ''}`}
        onMouseEnter={this.showTooltip}
        onMouseLeave={this.hideTooltip}
        onClick={this.setActiveProject}
      >
        <Tooltip isVisible={tooltipVisible} top={-20}>
          <div className={styles.tooltipInner}>
            <div className={styles.tooltipContent}>
              <h3 className={styles.tooltipHeading}>{project.name}</h3>
              {this.renderSubtitle()}
              <p className={`${styles.tooltipInfo} ${styles.tooltipInfoDark}`}>
                Cluster: {clusterAcronyms[project.cluster]}
              </p>
              <p className={styles.tooltipInfo}>{this.renderBudget()}</p>
              {this.renderButton()}
            </div>
          </div>
        </Tooltip>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  activeProject: selectors.getActiveProject(state),
  tabChangeRequested: selectors.tabChangeRequested(state),
});

const mapDispatchToProps = {
  setActiveProject,
};

BudgetBubble.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  project: PropTypes.object,
  isStriped: PropTypes.bool,
  setActiveProject: PropTypes.func,
  activeProject: PropTypes.object,
  tabChangeRequested: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(BudgetBubble);



// WEBPACK FOOTER //
// ./src/components/budget-bubble/budget-bubble.js